import { Navigate, useLocation } from 'react-router-dom';
import { FC, JSX } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../services/types/store-types';
import { useAuthContext } from '../../context/AuthContext';

type ProtectedRouteProps = {
  guest?: boolean;
  children: JSX.Element;
};

export const ProtectedRoute: FC<ProtectedRouteProps> = ({
  children,
  guest = false,
}) => {
  const isAuth = localStorage.getItem('authToken');
  const location = useLocation();

  const { userRole } = useAuthContext();
  const from = location.state?.from.pathname || '/';

  const protectedRoutes = ['/map', '/operator', '/config', '/planner'];

  const access = protectedRoutes.includes(location.pathname);

  if (!guest && !isAuth) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (userRole === 'usr' && access) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (guest && isAuth) {
    return <Navigate to={from} />;
  }

  return children;
};
